var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayed)?_c('div',{staticClass:"splash-screen"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"splash-screen__content"},[_c('img',{attrs:{"src":require("../assets/logo.svg"),"alt":"Kidjo TV","width":"70%"}}),_c('div',{staticClass:"loader"},[_c('div'),_c('div')])])
}]

export { render, staticRenderFns }